/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'about': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M544.4 276c26.8-.9 52.6 24.6 52.1 51.5-.5 25.7-22.9 48-48.9 48.9-26.8.9-49-19-51.1-45.8-2.2-28.2 20.1-53.7 47.9-54.6zm-65.8 173.2c9.4-3.9 19.4-6.6 29.3-8.8 46.8-10.3 70.6 11.3 60.6 57.9-9.3 43.2-22.8 85.5-33.1 128.5-2.5 10.5-3.1 23.7 1.2 33.2 23.7 52.9 14.6 72.1-42.3 84-6.7 1.4-13.4 2.3-18.2 3.1-35.8.3-54.7-22.3-46.8-57.5 9-39.8 20.4-79.1 31.6-118.3 5.7-20 8.7-36.8-4.7-57.4-19-28.8-8.8-51.7 22.4-64.7zM957 560c-6 56.4-22.4 110.2-49.2 160.5-3.2 6-6.2 12.2-10.1 17.8-18 26-39 33.2-60.4 21-21.8-12.4-25.5-32.9-14.5-62.1 16.1-42.8 36.8-85.2 44.5-129.7 33.1-191-91.7-368.4-284.6-410.1-183-39.6-372.9 74.4-420.8 256.8-39.1 149.3.5 279.4 119.6 377.2 117.4 96.4 250.2 108.7 389 45.7 10.9-4.9 20.7-12.1 31.7-16.6 21.4-8.7 40.4-5.1 54.1 14.8 13 19 8.6 41.9-12.7 58.3-12 9.3-26 16.4-39.8 23C408.3 1058.2 64.2 842.5 63.1 515 62.2 259 274 52.8 525.7 64.7 789.5 77.2 984.5 300.6 957 560z" _fill="#191919"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/about.js